var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.23 11.1999C21.23 11.9299 20.759 12.5799 19.94 12.9899L3.52003 21.1999C3.12003 21.3999 2.73003 21.4999 2.37003 21.4999C1.84903 21.4999 1.39003 21.2799 1.09903 20.8909C0.850026 20.5499 0.610026 19.9599 0.900026 18.9999L2.75003 12.8299C2.81003 12.6499 2.85003 12.4309 2.87003 12.1999H13C13.55 12.1999 14 11.7499 14 11.1999C14 10.6499 13.55 10.1999 13 10.1999H2.87003C2.84903 9.96992 2.80903 9.74992 2.75003 9.56992L0.900026 3.39992C0.610026 2.43992 0.850026 1.84992 1.10003 1.50992C1.59003 0.849921 2.52003 0.699921 3.52003 1.19992L19.941 9.40992C20.76 9.81992 21.23 10.4699 21.23 11.1999Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paperPlane.ab329a82f955e426c4db18100561ecad.svg";
export { ForwardRef as ReactComponent };